//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ButtonBlock from 'components/blocks/Button.vue'

export default {
  props: ["data"],
  block: 'ToggleButtons',
  components: {
    ButtonBlock,
  },
  methods: {
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
    toggleButtons(button, index) {
      // Reset all buttons
      this.data.buttons.forEach( (button) => {
        button.active = false;
      });

      button.active = true;
      this.$emit('toggleButton', index);
    }
  }
}



// WEBPACK FOOTER //
// ./components/blocks/ToggleButtons.vue